import { __assign } from 'tslib';
import React, { isValidElement } from 'react';
import cn from 'classnames';
import { Checkmark as Checkmark$1 } from '../checkmark/Component.js';
import { Checkmark } from '../checkmark-mobile/Component.js';
import '../../../../badge/esm';
import '../../../../checkbox/esm';
import '@alfalab/icons-glyph/CheckmarkCircleMIcon';
import '@alfalab/icons-glyph/CheckmarkMIcon';

var styles = {"option":"select__option_1y8zj","disabled":"select__disabled_1y8zj","s":"select__s_1y8zj","m":"select__m_1y8zj","l":"select__l_1y8zj","xl":"select__xl_1y8zj","selected":"select__selected_1y8zj","highlighted":"select__highlighted_1y8zj","content":"select__content_1y8zj","textContent":"select__textContent_1y8zj"};
require('./index.css');

var Option = function (_a) {
    var _b, _c;
    var _d = _a.size, size = _d === void 0 ? 's' : _d, className = _a.className, option = _a.option, children = _a.children, selected = _a.selected, highlighted = _a.highlighted, disabled = _a.disabled, multiple = _a.multiple, mobile = _a.mobile, _e = _a.Checkmark, Checkmark$2 = _e === void 0 ? mobile ? Checkmark : Checkmark$1 : _e, innerProps = _a.innerProps, dataTestId = _a.dataTestId;
    var content = children || option.content || option.key;
    var _f = option.showCheckMark, showCheckMark = _f === void 0 ? true : _f;
    return (React.createElement("div", __assign({}, innerProps, { className: cn(styles.option, styles[size], className, (_b = {},
            _b[styles.highlighted] = !mobile && highlighted,
            _b[styles.selected] = selected,
            _b[styles.disabled] = disabled,
            _b)), "data-test-id": dataTestId }),
        Checkmark$2 && showCheckMark && (React.createElement(Checkmark$2, { disabled: disabled, selected: selected, multiple: multiple, position: 'before' })),
        React.createElement("div", { className: cn(styles.content, (_c = {},
                _c[styles.textContent] = !isValidElement(content),
                _c)) }, content),
        Checkmark$2 && showCheckMark && (React.createElement(Checkmark$2, { disabled: disabled, selected: selected, multiple: multiple, position: 'after' }))));
};

export { Option };
